<template>
  <form class="form" @submit.prevent="checkUserName">
    <h1 class="heading">{{ $t("password recovery") }}</h1>
    <div class="input-container">
      <label class="label">{{ $t("user name") }}</label>
      <input
        v-model="userName"
        type="text"
        :placeholder="$t('user name')"
        class="input"
      />
    </div>
    <div class="submit">
      <button class="submit-button button filled">
        {{ $t("confirm") }}
      </button>
      <router-link to="/auth/login" class="login-button">{{
        $t("entrance")
      }}</router-link>
    </div>
  </form>
</template>

<script>
import { FhsAxios } from "@/services/axios";

export default {
  name: "RecoveryByEmailForm",
  data() {
    return {
      userName: "",
      statusmsg: ""
    };
  },
  methods: {
    checkUserName() {
      FhsAxios.post("user/request-reset", {
        email: this.userName
      }).then(response => {
        // console.log(response.data.status);
        let statusMsg = response.data.statusmsg;
        this.$emit("formStatus", response.data.status != 0);
        if (response.data.status) {
          // console.log(statusMsg);
          let successMsg = response.data.statusmsg;
          this.$emit("success", successMsg);
          return;
        }
        this.$toasted.error(response.data.statusmsg);
      });
    }
  }
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
}

.heading {
  margin-bottom: 20px;
  font-weight: normal;
  font-size: 36px;
}

.input-container {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label {
  font-size: 15px;
}

.input {
  width: 70%;
  padding: 10px;
  font-size: 15px;
  outline: none;
  background-color: #ffffff;
  border: 1px solid #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.submit {
  margin-top: 20px;
  width: 70%;
  align-self: flex-end;
  display: flex;
  align-items: center;
}

.submit-button {
  padding: 15px 60px;
}

.login-button {
  margin-left: 18px;
  font-size: 13px;
  color: #acb5c5;
  text-decoration: none;
}
.recovery__error {
  margin: 30px 0 0;
  text-align: center;
  color: #ef4748;
}
</style>
